import { render, staticRenderFns } from "./ys7.vue?vue&type=template&id=39f21569&scoped=true&"
import script from "./ys7.vue?vue&type=script&lang=js&"
export * from "./ys7.vue?vue&type=script&lang=js&"
import style0 from "./ys7.vue?vue&type=style&index=0&id=39f21569&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f21569",
  null
  
)

export default component.exports